import App from "./App";

import r2wc from "@r2wc/react-to-web-component";

const AirportSearchComponentWC = r2wc(App);

customElements.define("airport-search-comp-wc", AirportSearchComponentWC);
